/**
 * Inline Bitcoin mark (orange disc, tilted white ₿) so the FTUE game stays
 * network-free — the snake surfaces load their currency icon from an
 * admin-configured URL, which this component deliberately doesn't depend on.
 */
export function BtcLogo({ className }: { className?: string }) {
  return (
    <svg viewBox="0 0 32 32" className={className} role="img" aria-label="Bitcoin">
      <circle cx="16" cy="16" r="16" fill="#F7931A" />
      <text
        x="16"
        y="16"
        textAnchor="middle"
        dominantBaseline="central"
        transform="rotate(14 16 16)"
        fill="#fff"
        fontSize="19"
        fontWeight="700"
        fontFamily="ui-sans-serif, system-ui, sans-serif"
      >
        ₿
      </text>
    </svg>
  );
}
